import { forwardRef, Inject, Injectable } from '@angular/core';
import { HttpAuthService } from '@shared/service/http-auth.service';
import { Observable } from 'rxjs/Observable';
import { Utilities } from '@shared/utilities/utilities.model';
import {DigitalSignCheckLastDossier, DigitalSignSigners} from '../models/digital-sign-check-last-dossier.model';
import { DigitalSignNewDossier } from 'app/digital-sign/models/digital-sign-new-dossier';
import {Headers, RequestMethod, RequestOptions, RequestOptionsArgs, Response, ResponseContentType} from '@angular/http';
import { DigitalSignUtilities } from '../utilities/digital-sign-utilities.model';
import { SelectCommoditiesService } from '@shared/service/select-commodities.service';
import { AppConfigEnvironment } from '@shared/models/appconfig-environment.model';
import { AppConfigEnvironmentService } from '@shared/service/appconfig-environment.service';
import {DigitalSignSigner} from '../models/digital-sign-signer.model';

@Injectable()
export class DigitalSignService {

    json = '{"dossier_id":"d6ffd631-d1af-4103-9ea3-c63c9aca2d68","infocert_dossier_id":"40340350-20181008081033","company_id":"ALD_AUTOMOTIVE","dossier_type":"DEVISU_ONESHOT","client_dossier_type":"adc","client_dossier_reference_type":"orders","client_dossier_reference_id":"40340350","signers":{"richiedente1":{"client_signer_id":"1ce02a2c-628c-878f-55a9-3f956ad9368d","infocert_signer_id":"richiedente1","role":"richiedente","identity_assertion_policy":"inline.devisu","legal_id_country_code":"none","legal_id_serial_type":"CF","legal_id_serial_number":"TSTFPP85A29H501H","fiscal_code":"TSTFPP85A29H501H","first_name":"FILIPPO ","last_name":"TESTA","birth_date":"1985-01-29T00:00:00+0000","sex":"M","birth_place":"ROMA","email":"TESTAFILIPPO@FASTWEBNET.IT","mobile_number":"3389511068","address_street":"VIA FILIPPO DE GRENET","address_number":"69","address_zip":"00128","address_city":"ROMA","identity_document_issue_country":"IT","identity_document_type":"PT","identity_document_number":"U1C149876S","identity_document_issuer":"MIT-UCO","identity_document_issue_date":"2014-02-11T00:00:00+0000","identity_document_expiration_date":"2024-01-29T00:00:00+0000","process_token":"3eedf800-1d58-482f-b573-040eec3f6140","process_status":"COMPLETED","process_task_name":"oneshot","process_task_id":"311537764","process_session_key":"4570e4bc0a5bd826c64445764dcdf49d984ee0722bc36b93cecf40df878ffd3fb9b2840bd60f08bea75e4c21206f445dc7bb87e9b4d9f2590385631375191830dd137ddc80dc78ed7aac6d0fa7bf65965aa881cbc6ddcca1e708aafbbb9cedefa971b70e90ad05cb0b63c5c0260b630bb82203b2f615a014ad98ef07c9313500"},"IR1":{"client_signer_id":"623d5508-637b-4fca-3c0f-27162a9238a5","infocert_signer_id":"IR1","role":"IR","identity_assertion_policy":"none","legal_id_country_code":"IT","legal_id_serial_type":"CF","legal_id_serial_number":"DSNVLR88P17H501Z","fiscal_code":"DSNVLR88P17H501Z","first_name":"Valerio","last_name":"Disante","birth_date":"1988-09-17T00:00:00+0200","sex":"","birth_place":"Roma","birth_province":"RM","birth_country":"I","email":"info@europacarpoint.it","mobile_number":"3423909602","certificate_domain":"ALD","certificate_alias":"DSNVLR88P17H501Z_ALD_01","process_token":"5dd9323a-1fcd-4869-b33a-e91bd45075c1","process_status":"COMPLETED","process_task_name":"devisu","process_task_id":"311537774","process_session_key":"82a8149a73a5fd23b6e49e0236d4db8b537ad8a626c47dc37ba280996bbb3e519f2ad45cc1e4de71a613b2b7c0093c5e4f200ab2aa2862595012b18c5990c628ebc0d06aea4ff9cc0f4445703f783acb1abd7694fca7eb13a1c71e9d363b11005611704bcb9f9c60d04533c96f6e54236a8921cfb0d207618fceeb90fed74c8e"}},"documents":{"identita-fronte":{"client_document_id":"0a9a128b-693a-ba8f-7f07-ada5c698216d","infocert_document_id":"identita-fronte","infocert_document_type":"identita-fronte","infocert_signer_id":"richiedente1","policy_compose":false,"policy_sign":false,"policy_archive":false,"file_manager_id":"fe79dca8-0e75-4edf-b80f-5b681275ef8f","signature_fields":[]},"identita-retro":{"client_document_id":"d027d06a-3701-f4a8-dae1-f9551dd3b572","infocert_document_id":"identita-retro","infocert_document_type":"identita-retro","infocert_signer_id":"richiedente1","policy_compose":false,"policy_sign":false,"policy_archive":false,"file_manager_id":"a3505018-06ba-4bf0-a00c-952fc3b123ef","signature_fields":[]},"codice-fiscale-fronte":{"client_document_id":"c15fbbdb-c572-8b14-1946-9c9b356eb523","infocert_document_id":"codice-fiscale-fronte","infocert_document_type":"codice-fiscale-fronte","infocert_signer_id":"richiedente1","policy_compose":false,"policy_sign":false,"policy_archive":false,"file_manager_id":"a734f60c-06a9-4eac-b0db-45e90319dab8","signature_fields":[]},"codice-fiscale-retro":{"client_document_id":"4faa70e2-a7c1-168e-c31b-9fe969aa2924","infocert_document_id":"codice-fiscale-retro","infocert_document_type":"codice-fiscale-retro","infocert_signer_id":"richiedente1","policy_compose":false,"policy_sign":false,"policy_archive":false,"file_manager_id":"2032d5e0-7ea3-4bf8-b569-0dc72194af63","signature_fields":[]},"ALD-adc1":{"client_document_id":"9076a196-6c64-2f44-aeb6-825dbdede862","infocert_document_id":"ALD-adc1","infocert_document_type":"adc","policy_compose":false,"policy_sign":true,"policy_archive":true,"file_manager_id":"44909a03-672b-4933-866e-b7005118194b","signature_fields":[{"signer_id":"richiedente1","name":"driver_signature","reason":"Dichiarazione del sottoscrittore","location":""},{"signer_id":"IR1","name":"ir_signature","reason":"Dati veicolo a noleggio e/o dati veicolo pre-rent e accessori","location":""}],"archiving_policy":{"document_class":"verbali_service_point","attributes":{"doc_type":"adc","file_manager_id":"44909a03-672b-4933-866e-b7005118194b","order_id":"40340350","plate":"FS824BF","reference_id":"40340350","reference_type":"orders","signer_complete_name":"FILIPPO  TESTA","signer_fiscal_code":"TSTFPP85A29H501H","society_name":"FILIPPO TESTA"}}}},"response":{"status_code":200,"response_body":{"process":{"processStatus":"COMPLETED"},"enrollment":{"status":"COMPLETED","documents":[{"id":"ALD-adc1","name":"adc_311537649","status":"SIGNED","url":"content/311539934?token=4570e4bc0a5bd826c64445764dcdf49d984ee0722bc36b93cecf40df878ffd3fb9b2840bd60f08bea75e4c21206f445dc7bb87e9b4d9f2590385631375191830dd137ddc80dc78ed7aac6d0fa7bf65965aa881cbc6ddcca1e708aafbbb9cedefa971b70e90ad05cb0b63c5c0260b630bb82203b2f615a014ad98ef07c9313500","type":"adc","signatures":[{"id":"driver_signature","text":"Dichiarazione del sottoscrittore"}]},{"id":"ca-contract-richiedente1","name":"Contratto CA 201850535513108","status":"SIGNED","url":"content/311539970?token=4570e4bc0a5bd826c64445764dcdf49d984ee0722bc36b93cecf40df878ffd3fb9b2840bd60f08bea75e4c21206f445dc7bb87e9b4d9f2590385631375191830dd137ddc80dc78ed7aac6d0fa7bf65965aa881cbc6ddcca1e708aafbbb9cedefa971b70e90ad05cb0b63c5c0260b630bb82203b2f615a014ad98ef07c9313500","type":"ca-contract","signatures":[{"id":"dichiarazione","text":"approvo le Condizioni Generali che mi sono state sottoposte e confermo che intendo firmare il Contratto;"},{"id":"clausole","text":"approvo specificatamente, ai sensi degli artt. 1341 e 1342, c.c., le disposizioni delle Condizioni Generali di Contratto di seguito indicate: art. 1, art. 3, art. 5, art. 6, art. 9, art. 10, art. 11, art. 13, art. 14, art. 15, art. 16."}]}]}},"error_message":""},"state":50,"state_label":"SIGNATURE_PROCESS_COMPLETED","state_details":[],"created_at":"2018-10-08T08:10:33+00:00","updated_at":"2018-10-08T08:12:31+00:00"}';

    public static environmentStatic: AppConfigEnvironment;
    public environment: AppConfigEnvironment;

    static getEntryPoint(type: string): string {
        switch (type) {
            case DigitalSignUtilities.ORDERS_TYPE:
                return DigitalSignService.environmentStatic.GW_API;
            case DigitalSignUtilities.CONTRACT_CLOSE_TYPE:
                return DigitalSignService.environmentStatic.NEMO_CONTRACT_CLOSING_API;
            case DigitalSignUtilities.USER_CHANGE:
                return DigitalSignService.environmentStatic.USER_CHANGE_API;
        }
        return '';
    }

    constructor(@Inject(forwardRef(() => HttpAuthService)) public httpAuthService: HttpAuthService,
        private selectCommoditiesService: SelectCommoditiesService,
        private appConfig: AppConfigEnvironmentService) {
        DigitalSignService.environmentStatic = appConfig.Environment;
        this.environment = appConfig.Environment;
    }

    checkLastDossier(resourceId: any, type: string): Observable<DigitalSignCheckLastDossier> {
			let urlDS = '';
			let options: RequestOptionsArgs;
			switch (type) {
				case DigitalSignUtilities.ORDERS_TYPE:
					const contractNumber = +resourceId;
					urlDS = '/' + type + '/' + contractNumber + '/delivery/certificate/ds_check_last_dossier';
					options = Utilities.setRequestOptionGW(this.selectCommoditiesService.getAldCommodityIds());
					break;
				case DigitalSignUtilities.CONTRACT_CLOSE_TYPE:
					urlDS = '/contracts/' + resourceId + '/dossier/last';
					break;
			}
			const url: string = DigitalSignService.getEntryPoint(type) + urlDS;
			return new Observable<DigitalSignCheckLastDossier>(
				observer => {
                    this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options).subscribe(
                        response => {
                            if (!Utilities.isVoid(response) && response.status === 200) {
                                try {
                                    observer.next(new DigitalSignCheckLastDossier(type, response.json()));
                                } catch (error) {
                                    observer.error(error);
                                }
                            } else {
                                observer.error('no response');
                            }
                        },
                        error => {
                            observer.error(error);
                        });
				});
    }

    getDossier(resourceId: any, type: string, dossierId: string): Observable<DigitalSignCheckLastDossier> {
            let urlDS = '';
	    let options: RequestOptionsArgs;
	    switch (type) {
                case DigitalSignUtilities.ORDERS_TYPE:
					const contractNumber = +resourceId;
                    urlDS = '/' + type + '/' + contractNumber + '/delivery/certificate/dossier/';
	                options = Utilities.setRequestOptionGW(this.selectCommoditiesService.getAldCommodityIds());
	                break;
                case DigitalSignUtilities.CONTRACT_CLOSE_TYPE:
                    urlDS = '/contracts/' + resourceId + '/dossier/';
                    break;
            }
            const url: string = DigitalSignService.getEntryPoint(type) + urlDS + dossierId;
            return new Observable<DigitalSignCheckLastDossier>(
                observer => {
                        this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options)
                            .subscribe(
                                response => {
                                    if (!Utilities.isVoid(response)) {
                                        if (response.status === 200) {
                                            try {
                                                observer.next(new DigitalSignCheckLastDossier(type, response.json()));
                                            } catch (error) {
                                                observer.error(error);
                                            }
                                        } else {
                                            observer.error(DigitalSignUtilities.extractErrorMessageFromBE(response));
                                        }
                                    } else {
                                        observer.error(response.status);
                                    }
                                },
                                error => {
                                    observer.error(error);
                                });
                });
    }

    createDossier(resourceId: any, type: string, deliveryCertificateId: string, digitalSignNewProcess: DigitalSignNewDossier): Observable<Response> {
        let url = DigitalSignService.getEntryPoint(type);
	    let options: RequestOptionsArgs;
	    switch (type) {
            case DigitalSignUtilities.ORDERS_TYPE:
				const contractNumber = +resourceId;
                url = url + '/' + type + '/' + contractNumber + '/delivery/certificate/' + deliveryCertificateId + '/ds_new_dossier';
	            options = Utilities.setRequestOptionGW(this.selectCommoditiesService.getAldCommodityIds());
	            break;
            case DigitalSignUtilities.CONTRACT_CLOSE_TYPE:
                url = url + '/contracts/' +  resourceId + '/dossier';
                break;
        }
        return this.sendPost(url, digitalSignNewProcess, options);
    }

    abortDossier(resourceId: any, type: string, dossierId: string): Observable<Response> {
	    let options: RequestOptionsArgs;
        let url = DigitalSignService.getEntryPoint(type);
        switch (type) {
            case DigitalSignUtilities.ORDERS_TYPE:
				const contractNumber = +resourceId;
                url = url + '/' + type + '/' + contractNumber + '/delivery/certificate/dossier/' + dossierId + '/abort';
	            options = Utilities.setRequestOptionGW(this.selectCommoditiesService.getAldCommodityIds());
	            break;
            case DigitalSignUtilities.CONTRACT_CLOSE_TYPE:
                url = url + '/contracts/' + resourceId + '/dossier/' + dossierId + '/abort';
                break;
        }
        return this.sendPost(url, null, options);
    }

    startSignerProcess(resourceId: any, type: string, dossierId: string, signerId: string): Observable<Response> {
        let url = DigitalSignService.getEntryPoint(type);
	    let options: RequestOptionsArgs;
	    switch (type) {
            case DigitalSignUtilities.ORDERS_TYPE:
				const contractNumber = +resourceId;
                url = url + '/' + type + '/' + contractNumber + '/delivery/certificate/dossier/' + dossierId + '/' + signerId + '/start';
	            options = Utilities.setRequestOptionGW(this.selectCommoditiesService.getAldCommodityIds());
	            break;
            case DigitalSignUtilities.CONTRACT_CLOSE_TYPE:
                url = url + '/contracts/' + resourceId + '/dossier/' + dossierId + '/' + signerId + '/start';
                break;
        }
        return this.sendPost(url, null, options);
    }

    completeSignerProcess(resourceId: any, type: string, dossierId: string, signerId: string, body: any): Observable<Response> {
        let url = DigitalSignService.getEntryPoint(type);
	    let options: RequestOptionsArgs;
	    switch (type) {
            case DigitalSignUtilities.ORDERS_TYPE:
				const contractNumber = +resourceId;
                url = url + '/' + type + '/' + contractNumber + '/delivery/certificate/dossier/' + dossierId + '/' + signerId + '/complete';
	            options = Utilities.setRequestOptionGW(this.selectCommoditiesService.getAldCommodityIds());
	            break;
            case DigitalSignUtilities.CONTRACT_CLOSE_TYPE:
                url = url + '/contracts/' + resourceId + '/dossier/' + dossierId + '/' + signerId + '/complete';
                break;
        }
        return this.sendPost(url, body, options);
    }

    signSignerProcess(resourceId: any, type: string, dossierId: string, signerId: string, body: any): Observable<Response> {
        let url = DigitalSignService.getEntryPoint(type);
	    let options: RequestOptionsArgs;
	    switch (type) {
            case DigitalSignUtilities.ORDERS_TYPE:
				const contractNumber = +resourceId;
                url = url + '/' + type + '/' + contractNumber + '/delivery/certificate/dossier/' + dossierId + '/' + signerId + '/sign';
	            options = Utilities.setRequestOptionGW(this.selectCommoditiesService.getAldCommodityIds());
	            break;
            case DigitalSignUtilities.CONTRACT_CLOSE_TYPE:
                url = url + '/contracts/' + resourceId + '/dossier/' + dossierId + '/' + signerId + '/sign';
                break;
        }
        return this.sendPost(url, body, options);
    }

    newOtpSignerProcess(resourceId: any, type: string, dossierId: string, signerId: string): Observable<Response> {
        let url = DigitalSignService.getEntryPoint(type);
	    let options: RequestOptionsArgs;
	    switch (type) {
            case DigitalSignUtilities.ORDERS_TYPE:
				const contractNumber = +resourceId;
                url = url + '/' + type + '/' + contractNumber + '/delivery/certificate/dossier/' + dossierId + '/' + signerId + '/otp';
	            options = Utilities.setRequestOptionGW(this.selectCommoditiesService.getAldCommodityIds());
	            break;
            case DigitalSignUtilities.CONTRACT_CLOSE_TYPE:
                url = url + '/contracts/' + resourceId + '/dossier/' + dossierId + '/' + signerId + '/otp';
                break;
            case DigitalSignUtilities.USER_CHANGE:
                url = url + '/contracts/' + resourceId + '/dossier/' + dossierId + '/' + signerId + '/otp';
                break;
        }
        return this.sendPost(url, null, options);
    }


    downloadFile(mUrl: string, token: string): Observable<Response> {
        const url = this.environment.ENTRY_POINT_INFOCERT_DOCUMENTS + mUrl;
        const options = new RequestOptions();

        options.responseType = ResponseContentType.Blob;
        options.headers = new Headers();
        const aut = 'COP ' + token;
        options.headers.set('Authorization', aut);
        return this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options);
    }

    private sendPost(url: string, body: any, options: RequestOptionsArgs): Observable<Response> {
        return this.httpAuthService.post(url, body, this.environment.ROOT_REDIRECT, options);
    }

    loadInfocertDocument(urlFile: any, token: string): Observable<string> {
        return new Observable<string>(subscriber => {
            this.downloadFile(urlFile, token).subscribe(
                response => {
                    if (!Utilities.isVoid(response) && response.status === 200) {
                        try {
                            const fileBlob = response.blob();
                            const blob = new Blob([fileBlob], { type: fileBlob.type });
                            const reader = new FileReader();
                            reader.readAsDataURL(blob);
                            reader.onload = () => {
                                subscriber.next(reader.result);
                            };
                            reader.onerror = (error) => {
                                subscriber.error(error);
                            };
                        } catch (e) {
                            subscriber.error(e);
                        }
                    } else {
                        subscriber.error(null);
                    }
                }, error => {
                    subscriber.error(error);
                });
        });
    }



	getcheckLastDossierMOCK(type: string): DigitalSignCheckLastDossier {
		const dscl = new DigitalSignCheckLastDossier(type);
		dscl.dossier_id = 'd6ffd631-d1af-4103-9ea3-c63c9aca2d68';
		dscl.infocert_dossier_id = '40340350-20181008081033';
		dscl.company_id = 'ALD_AUTOMOTIVE';
		dscl.dossier_type = 'DEVISU_ONESHOT';
		dscl.client_dossier_type = 'adc';
		dscl.client_dossier_reference_type = 'orders';
		dscl.client_dossier_reference_id = '40340350';
		dscl.state = 20;
		dscl.state_label = 'SIGNATURE_PROCESS_COMPLETED';
		dscl.state_details = [];
		dscl.created_at = '2018-10-08T08:10:33+00:00';
		dscl.updated_at = '2018-10-08T08:12:31+00:00';

		const response = '{"response":{"status_code":200,"response_body":{"process":{"processStatus":"COMPLETED"},"enrollment":{"status":"COMPLETED","documents":[{"id":"ALD-adc1","name":"adc_311537649","status":"SIGNED","url":"content/311539934?token=4570e4bc0a5bd826c64445764dcdf49d984ee0722bc36b93cecf40df878ffd3fb9b2840bd60f08bea75e4c21206f445dc7bb87e9b4d9f2590385631375191830dd137ddc80dc78ed7aac6d0fa7bf65965aa881cbc6ddcca1e708aafbbb9cedefa971b70e90ad05cb0b63c5c0260b630bb82203b2f615a014ad98ef07c9313500","type":"adc","signatures":[{"id":"driver_signature","text":"Dichiarazione del sottoscrittore"}]},{"id":"ca-contract-richiedente1","name":"Contratto CA 201850535513108","status":"SIGNED","url":"content/311539970?token=4570e4bc0a5bd826c64445764dcdf49d984ee0722bc36b93cecf40df878ffd3fb9b2840bd60f08bea75e4c21206f445dc7bb87e9b4d9f2590385631375191830dd137ddc80dc78ed7aac6d0fa7bf65965aa881cbc6ddcca1e708aafbbb9cedefa971b70e90ad05cb0b63c5c0260b630bb82203b2f615a014ad98ef07c9313500","type":"ca-contract","signatures":[{"id":"dichiarazione","text":"approvo le Condizioni Generali che mi sono state sottoposte e confermo che intendo firmare il Contratto;"},{"id":"clausole","text":"approvo specificatamente, ai sensi degli artt. 1341 e 1342, c.c., le disposizioni delle Condizioni Generali di Contratto di seguito indicate: art. 1, art. 3, art. 5, art. 6, art. 9, art. 10, art. 11, art. 13, art. 14, art. 15, art. 16."}]}]}},"error_message":""}}';
		dscl.response = JSON.parse(response);
		return dscl;
	}

	getDossierMOCK(type: string): DigitalSignCheckLastDossier {

		const r = {
			citizenship: 'it',
			client_signer_id: '1ce02a2c-628c-878f-55a9-3f956ad9368d',
			infocert_signer_id: 'richiedente1',
			role: 'richiedente',
			identity_assertion_policy: 'inline.devisu',
			legal_id_country_code: 'none',
			legal_id_serial_type: 'CF',
			legal_id_serial_number: 'TSTFPP85A29H501H',
			fiscal_code: 'TSTFPP85A29H501H',
			first_name: 'FILIPPO ',
			last_name: 'TESTA',
			birth_date: '1985-01-29T00:00:00+0000',
			sex: 'M',
			birth_place: 'ROMA',
			email: 'TESTAFILIPPO@FASTWEBNET.IT',
			mobile_number: '3389511068',
			address_street: 'VIA FILIPPO DE GRENET',
			address_number: '69',
			address_zip: '00128',
			address_city: 'ROMA',
			identity_document_issue_country: 'IT',
			identity_document_type: 'PT',
			identity_document_number: 'U1C149876S',
			identity_document_issuer: 'MIT-UCO',
			identity_document_issue_date: '2014-02-11T00:00:00+0000',
			identity_document_expiration_date: '2024-01-29T00:00:00+0000',
			process_token: '3eedf800-1d58-482f-b573-040eec3f6140',
			process_session_key: '4570e4bc0a5bd826c64445764dcdf49d984ee0722bc36b93cecf40df878ffd3fb9b2840bd60f08bea75e4c21206f445dc7bb87e9b4d9f2590385631375191830dd137ddc80dc78ed7aac6d0fa7bf65965aa881cbc6ddcca1e708aafbbb9cedefa971b70e90ad05cb0b63c5c0260b630bb82203b2f615a014ad98ef07c9313500'
		};
		const ir1 = {
			address_street: '',
			citizenship: 'it',
			client_signer_id: '623d5508-637b-4fca-3c0f-27162a9238a5',
			infocert_signer_id: 'IR1',
			role: 'IR',
			identity_assertion_policy: 'none',
			legal_id_country_code: 'IT',
			legal_id_serial_type: 'CF',
			legal_id_serial_number: 'DSNVLR88P17H501Z',
			fiscal_code: 'DSNVLR88P17H501Z',
			first_name: 'Valerio',
			last_name: 'Disante',
			birth_date: '1988-09-17T00:00:00+0200',
			sex: '',
			birth_place: 'Roma',
			birth_province: 'RM',
			birth_country: 'I',
			email: 'info@europacarpoint.it',
			mobile_number: '3423909602',
			certificate_domain: 'ALD',
			certificate_alias: 'DSNVLR88P17H501Z_ALD_01',
			process_token: '5dd9323a-1fcd-4869-b33a-e91bd45075c1',
			//'process_status': 'COMPLETED',
			//'process_task_name': 'devisu',
			//'process_task_id': '311537774',
			process_session_key: '82a8149a73a5fd23b6e49e0236d4db8b537ad8a626c47dc37ba280996bbb3e519f2ad45cc1e4de71a613b2b7c0093c5e4f200ab2aa2862595012b18c5990c628ebc0d06aea4ff9cc0f4445703f783acb1abd7694fca7eb13a1c71e9d363b11005611704bcb9f9c60d04533c96f6e54236a8921cfb0d207618fceeb90fed74c8e'
		};
		const richiedente1: DigitalSignSigner = new DigitalSignSigner(r);
		const i1: DigitalSignSigner = new DigitalSignSigner(ir1);
		const sig: DigitalSignSigners = {
			IR1: i1,
			richiedente1: richiedente1
		};



		const dscl = {
			dossier_id: 'd6ffd631-d1af-4103-9ea3-c63c9aca2d68',
			infocert_dossier_id: '40340350-20181008081033',
			company_id: 'ALD_AUTOMOTIVE',
			dossier_type: 'DEVISU_ONESHOT',
			client_dossier_type: 'adc',
			client_dossier_reference_type: 'orders',
			client_dossier_reference_id: '40340350',
			signers: sig,
			documents: {
				'identita-fronte': {
					'client_document_id': '0a9a128b-693a-ba8f-7f07-ada5c698216d',
					'infocert_document_id': 'identita-fronte',
					'infocert_document_type': 'identita-fronte',
					'infocert_signer_id': 'richiedente1',
					'policy_compose': false,
					'policy_sign': false,
					'policy_archive': false,
					'file_manager_id': 'fe79dca8-0e75-4edf-b80f-5b681275ef8f',
					'signature_fields': []
				},
				'identita-retro': {
					'client_document_id': 'd027d06a-3701-f4a8-dae1-f9551dd3b572',
					'infocert_document_id': 'identita-retro',
					'infocert_document_type': 'identita-retro',
					'infocert_signer_id': 'richiedente1',
					'policy_compose': false,
					'policy_sign': false,
					'policy_archive': false,
					'file_manager_id': 'a3505018-06ba-4bf0-a00c-952fc3b123ef',
					'signature_fields': []
				},
				'codice-fiscale-fronte': {
					'client_document_id': 'c15fbbdb-c572-8b14-1946-9c9b356eb523',
					'infocert_document_id': 'codice-fiscale-fronte',
					'infocert_document_type': 'codice-fiscale-fronte',
					'infocert_signer_id': 'richiedente1',
					'policy_compose': false,
					'policy_sign': false,
					'policy_archive': false,
					'file_manager_id': 'a734f60c-06a9-4eac-b0db-45e90319dab8',
					'signature_fields': []
				},
				'codice-fiscale-retro': {
					'client_document_id': '4faa70e2-a7c1-168e-c31b-9fe969aa2924',
					'infocert_document_id': 'codice-fiscale-retro',
					'infocert_document_type': 'codice-fiscale-retro',
					'infocert_signer_id': 'richiedente1',
					'policy_compose': false,
					'policy_sign': false,
					'policy_archive': false,
					'file_manager_id': '2032d5e0-7ea3-4bf8-b569-0dc72194af63',
					'signature_fields': []
				},
				'ALD-adc1': {
					'client_document_id': '9076a196-6c64-2f44-aeb6-825dbdede862',
					'infocert_document_id': 'ALD-adc1',
					'infocert_document_type': 'adc',
					'policy_compose': false,
					'policy_sign': true,
					'policy_archive': true,
					'file_manager_id': '44909a03-672b-4933-866e-b7005118194b',
					'signature_fields': [
						{
							'signer_id': 'richiedente1',
							'name': 'driver_signature',
							'reason': 'Dichiarazione del sottoscrittore',
							'location': ''
						},
						{
							'signer_id': 'IR1',
							'name': 'ir_signature',
							'reason': 'Dati veicolo a noleggio e/o dati veicolo pre-rent e accessori',
							'location': ''
						}
					],
					'archiving_policy': {
						'document_class': 'verbali_service_point',
						'attributes': {
							'doc_type': 'adc',
							'file_manager_id': '44909a03-672b-4933-866e-b7005118194b',
							'order_id': '40340350',
							'plate': 'FS824BF',
							'reference_id': '40340350',
							'reference_type': 'orders',
							'signer_complete_name': 'FILIPPO  TESTA',
							'signer_fiscal_code': 'TSTFPP85A29H501H',
							'society_name': 'FILIPPO TESTA'
						}
					}
				}
			},
			response: {
				'status_code': 200,
				'response_body': {
					'process': {
						'processStatus': 'COMPLETED'
					},
					'enrollment': {
						'status': 'COMPLETED',
						'documents': [
							{
								'id': 'ALD-adc1',
								'name': 'adc_311537649',
								'status': 'SIGNED',
								'url': 'content/311539934?token=4570e4bc0a5bd826c64445764dcdf49d984ee0722bc36b93cecf40df878ffd3fb9b2840bd60f08bea75e4c21206f445dc7bb87e9b4d9f2590385631375191830dd137ddc80dc78ed7aac6d0fa7bf65965aa881cbc6ddcca1e708aafbbb9cedefa971b70e90ad05cb0b63c5c0260b630bb82203b2f615a014ad98ef07c9313500',
								'type': 'adc',
								'signatures': [
									{
										'id': 'driver_signature',
										'text': 'Dichiarazione del sottoscrittore'
									}
								]
							},
							{
								'id': 'ca-contract-richiedente1',
								'name': 'Contratto CA 201850535513108',
								'status': 'SIGNED',
								'url': 'content/311539970?token=4570e4bc0a5bd826c64445764dcdf49d984ee0722bc36b93cecf40df878ffd3fb9b2840bd60f08bea75e4c21206f445dc7bb87e9b4d9f2590385631375191830dd137ddc80dc78ed7aac6d0fa7bf65965aa881cbc6ddcca1e708aafbbb9cedefa971b70e90ad05cb0b63c5c0260b630bb82203b2f615a014ad98ef07c9313500',
								'type': 'ca-contract',
								'signatures': [
									{
										'id': 'dichiarazione',
										'text': 'approvo le Condizioni Generali che mi sono state sottoposte e confermo che intendo firmare il Contratto;'
									},
									{
										'id': 'clausole',
										'text': 'approvo specificatamente, ai sensi degli artt. 1341 e 1342, c.c., le disposizioni delle Condizioni Generali di Contratto di seguito indicate: art. 1, art. 3, art. 5, art. 6, art. 9, art. 10, art. 11, art. 13, art. 14, art. 15, art. 16.'
									}
								]
							}
						]
					}
				},
				'error_message': ''
			},
			state: 20,
			state_label: 'SIGNATURE_PROCESS_COMPLETED',
			state_details: [],
			created_at: '2018-10-08T08:10:33+00:00',
			updated_at: '2018-10-08T08:12:31+00:00'
		};
		return new DigitalSignCheckLastDossier(type, dscl);
		// return a;
	}
}
